// @ts-check

import httpClient from "@/config/httpClient";

/**
 * @typedef {Record<string, unknown>} GenericQueryResponse
 */

/**
 * @param {Object} options
 * @param {"get" | "post" | "put" | "delete" | "patch"} [options.method]
 * @param {string} options.url
 * @param {Object} [options.payload]
 *
 * @returns {Promise<GenericQueryResponse>}
 *
 * @example
 * const { isError, response } = await genericQuery({
 * 	method: 'get',
 * 	url: '/api/users'
 * });
 *
 * const { isError, response } = await genericQuery({
 * 	method: 'put',
 * 	url: '/api/users/email'
 * 	payload: {email: 'a@a.es'}
 * });
 */
export async function genericQuery({ method = "get", url, payload }) {
	const { isError, response } = await httpClient[method](url, payload);

	if (isError) {
		throw new Error(response);
	}

	return response;
}
